import { createContext } from 'react';

type TTimelineSectionContext = {
  section: TimelineSection;
  isDontPlay?: boolean;
  isHeadLine?: boolean;
};

export const TimelineSectionContext = createContext<TTimelineSectionContext>(undefined!);
